/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Membership Plan
 */
export type MembershipPlanFileRecordItem = {
    /**
     * API Response Version
     */
    _ver?: number;
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Membership Plan Unique ID
     */
    membershipPlanId?: number;
    /**
     * awsUrl for image
     */
    awsUrl?: string;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * createdBy Unique ID
     */
    createdBy?: number;
    /**
     * updatedBy Unique ID
     */
    updatedBy?: number;
    /**
     * File Type
     */
    fileType?: MembershipPlanFileRecordItem.fileType;
    /**
     * Flag for record being active
     */
    active?: boolean;
    /**
     * Flag for default logo/image
     */
    default?: boolean;
    /**
     * Membership Plan File URL
     */
    url?: string;
}

export namespace MembershipPlanFileRecordItem {

    /**
     * File Type
     */
    export enum fileType {
        LOGO = 'logo',
        IMAGE = 'image',
        PDF = 'pdf',
        PPTX = 'pptx',
        DOCX = 'docx',
    }


}
